export default "__VITE_ASSET__DPD0q5kk__"